<!-- src/components/dashboard/bookings/BookingLeadsMenu.vue -->
<!-- FT-156 REQ-08 (DEC-07): из карточки брони — в привязанные лиды CRM. Одна иконка с числом в
     панели шапки брони, по клику — список «№ · имя · стадия», клик по строке открывает лид.
     Гейт видимости (тариф crm_active ∧ crm_access_enabled сотрудника) — у родителя (BookingHeader):
     компонент вообще не монтируется без доступа, значит и запросов в CRM нет.
     Без initialSection — один запрос при открытии карточки; справочник стадий
     (три запроса) — лениво, при открытии меню. -->
<template>
  <v-menu v-if="items.length" v-model="open" offset-y :close-on-content-click="true">
    <template #activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" data-cy="booking-leads-menu"
             v-tooltip="{ content: $t('bookings.leads_menu.title'), placement: 'bottom-center', classes: ['black--text', 'white'], targetClasses: ['it-has-a-tooltip'], delay: { show: 500, hide: 500 } }">
        <v-badge :content="items.length" color="primary" overlap>
          <v-icon>mdi-account-group-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list dense>
      <v-subheader>{{ $t('bookings.leads_menu.title') }}</v-subheader>
      <!-- До справочника стадий строк нет (формат строки «№ · имя · стадия» обязателен) -->
      <div v-if="!referenceLoaded && !referenceError" class="text-center pa-3">
        <v-progress-circular indeterminate size="20" width="2" color="primary" />
      </div>
      <v-list-item v-else-if="referenceError" disabled>
        <v-list-item-title class="grey--text">{{ $t('bookings.leads_menu.empty') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-for="row in rows" v-else :key="row.id" data-cy="booking-leads-menu-row" @click="openLead(row.id)">
        <v-list-item-title>
          <span class="bl-mono">{{ row.number }}</span> · {{ row.name }} · <span class="grey--text">{{ row.stage }}</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from "vuex";
import { deserializeList } from "@/store/modules/crm/api";
import { readInitialSection } from "@/components/dashboard/cards/initialSection";
export default {
  name: "BookingLeadsMenu",
  props: {
    bookingId: { type: [Number, String], default: null },
    clientId: { type: [Number, String], default: null },
    initialSection: { type: Object, default: undefined },
    initialEntityId: { type: [Number, String], default: undefined },
  },
  data() { return { items: [], seq: 0, open: false, appliedInitialEntity: null, appliedInitialKey: null }; },
  computed: {
    ...mapState("crm", ["pipelines", "referenceLoaded", "referenceError"]),
    // Составной ключ: смена брони ИЛИ клиента в той же карточке — новый запрос.
    key() { return `${this.bookingId || ""}:${this.clientId || ""}`; },
    initialData() { return [this.key, this.initialSection, this.initialEntityId]; },
    stagesById() {
      const map = {};
      (this.pipelines || []).forEach((p) => (p.pipeline_stages || []).forEach((s) => { map[s.id] = s; }));
      return map;
    },
    rows() {
      return this.items.map((l) => {
        const st = this.stagesById[l.pipeline_stage_id] || l.pipeline_stage || null;
        return {
          id: l.id,
          number: `${this.$t("custom.number")}${l.id}`,
          name: [l.first_name, l.last_name].filter(Boolean).join(" ") || this.$t("crm.card.title_numbered", { n: l.id }),
          stage: st ? (st.display_name || st.name) : "",
        };
      });
    },
  },
  watch: {
    initialData: {
      immediate: true,
      handler(next, prev) {
        if (this.applyInitialData()) return;
        if (!prev || next[0] !== prev[0]) this.load();
      },
    },
    open(v) {
      // Справочник (воронки/источники/пользователи) — только когда меню открыли; идемпотентно.
      if (v) this.$store.dispatch("crm/fetchReferenceData");
    },
  },
  beforeDestroy() { ++this.seq; },
  methods: {
    applyInitialData() {
      const section = readInitialSection(this.initialSection);
      if (!section.provided) return false;
      const entity = String(this.bookingId);
      if (this.initialEntityId !== undefined && String(this.initialEntityId) !== entity) {
        ++this.seq;
        this.items = [];
        this.open = false;
        this.appliedInitialEntity = null;
        return true;
      }
      // A client change still uses the legacy query; same-id envelopes never
      // replace local data. CRM keeps booking leads locally, not in its board.
      if (this.appliedInitialEntity === entity) return this.appliedInitialKey === this.key;
      ++this.seq;
      this.open = false;
      this.appliedInitialEntity = entity;
      this.appliedInitialKey = this.key;
      this.items = ["ok", "empty"].includes(section.status) ? deserializeList(section.data || {}) : [];
      return true;
    },
    load() {
      this.items = [];
      const my = ++this.seq;
      this.appliedInitialKey = this.key;
      if (!this.bookingId) return;
      return this.$store.dispatch("crm/fetchBookingLeads", { bookingId: this.bookingId, clientId: this.clientId })
        .then((items) => { if (my === this.seq) this.items = Array.isArray(items) ? items : []; })
        .catch(() => { if (my === this.seq) this.items = []; }); // FM-05: 403/сеть — без тоста
    },
    openLead(id) {
      this.$router.push({ path: `/crm/leads/${id}` }).catch(() => {});
    },
  },
};
</script>

<style scoped>
/* Номер моноширинный: .crm-mono живёт под .crm-scope и вне CRM-страниц не действует */
.bl-mono { font-family: "JetBrains Mono", "SFMono-Regular", Menlo, Consolas, monospace; }
</style>
